<div class="wanted-level" *ngIf="wantedLevel > 0">
    <span *ngFor="let filled of stars" class="star" [class.star--filled]="filled">
        {{ filled ? '★' : '☆' }}
    </span>
</div>
